import _isEmpty from 'lodash/isEmpty';
import _debounce from 'lodash/debounce';

export const debounce = (fn, wait = 200, options = { maxWait: 5000 }) => {
  return _debounce(fn, wait, options);
};

export const isEmpty = (value) => {
  if (typeof value === 'number') {
    return false;
  }
  return _isEmpty(value);
};

export const isLocalHost = () => {
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === ''
  ) {
    return true;
  }
  return false;
};

export const hasValue = (data) => {
  return (
    data !== undefined &&
    data !== null &&
    (typeof data === 'string' ? data.length > 0 : true) &&
    (Array.isArray(data) ? data.length > 0 : true)
  );
};

export const closeCurrentWebTab = () => {
  return window.close();
};

export const delay = (time = 3000) => {
  return new Promise((resolve) => setTimeout(resolve, time));
};

export const convertAchivementsToString = (data, achievementYear) => {
  const objectAchivements = data.reduce(function (r, a) {
    r[a.achievementCode] = r[a.achievementCode] || [];
    r[a.achievementCode].push(a);
    return r;
  }, Object.create(null));
  let mdrt = '';
  let cot = '';
  let tot = '';
  for (const key in objectAchivements) {
    let achivementString = '';
    achivementString += key + ': ';
    if (objectAchivements[key] && objectAchivements[key].length > 0) {
      objectAchivements[key].sort((a, b) => a.year - b.year);
      if (achievementYear !== 'ALL') {
        objectAchivements[key] = objectAchivements[key].filter(
          (item) => item.year === parseInt(achievementYear),
        );
      }
      objectAchivements[key].forEach((item, index) => {
        if (!achivementString.includes(item.year)) {
          achivementString += item.year;
        }
        if (index === objectAchivements[key].length - 1) {
          achivementString += '';
        } else {
          achivementString += ', ';
        }
      });
      if (
        achievementYear !== 'ALL' &&
        !achivementString.includes(achievementYear)
      ) {
        achivementString = '';
      }
    }
    switch (key) {
      case 'MDRT':
        mdrt = achivementString.replace(/,\s*$/, '');
        break;
      case 'COT':
        cot = achivementString.replace(/,\s*$/, '');
        break;
      case 'TOT':
        tot = achivementString.replace(/,\s*$/, '');
        break;
    }
  }

  const achivementConvertArray = [];
  if (mdrt) {
    achivementConvertArray.push(mdrt);
  }
  if (cot) {
    achivementConvertArray.push(cot);
  }
  if (tot) {
    achivementConvertArray.push(tot);
  }

  return achivementConvertArray;
};

export const mapVietnameseNameForProfileName = (name) => {
  switch (name) {
    case 'AD':
      return 'Giám đốc PTKD';
    case 'AGT':
      return 'Tư vấn Tài chính';
    case 'BNK':
      return 'Tư vấn Tài chính';
    case 'GAD':
      return 'Giám đốc TĐL';
    default:
      return '';
  }
};

export const mapToListProfiles = (profiles) => {
  if (profiles && profiles.length > 0) {
    return profiles.map((profile) => {
      return {
        code: profile.code,
        name: profile.name,
        vietnamesName: mapVietnameseNameForProfileName(profile.name),
      };
    });
  }
  return [];
};
